import { Accordion, Checkbox, Group, Paper, Spoiler } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import filterList from "filters/overviewFilters";
import AccordionFilterLabel from "./AccordionFilterLabel";
import TotalCountBadge from "./TotalCountBadge";
import {
  decodeDelimitedArray,
  encodeDelimitedArray,
  useQueryParam,
  withDefault,
} from "use-query-params";

const CustomArrayParam = {
  encode: (array) => encodeDelimitedArray(array, "|"),
  decode: (arrayStr) => decodeDelimitedArray(arrayStr, "|"),
};

const CheckboxFilters = ({ countFilterResults }) => {
  const isMobile = useMediaQuery("(max-width: 992px)");

  const [houseType, setHouseType] = useQueryParam(
    "houseType",
    withDefault(CustomArrayParam, undefined)
  );
  const [popularFilters, setPopularFilters] = useQueryParam(
    "popularFilters",
    withDefault(CustomArrayParam, undefined)
  );

  const queryHandler = (type, value) => {
    if (type === "houseType") {
      if (!houseType?.includes(value)) {
        const query = houseType ? [...houseType, value] : [value];
        setHouseType(query);
      } else {
        const query = houseType.filter((item) => item !== value);
        setHouseType(query.length === 0 ? undefined : query);
      }
    }
    if (type === "popularFilters") {
      if (!popularFilters?.includes(value)) {
        const query = popularFilters ? [...popularFilters, value] : [value];
        setPopularFilters(query);
      } else {
        const query = popularFilters.filter((item) => item !== value);
        setPopularFilters(query.length === 0 ? undefined : query);
      }
    }
  };

  return filterList.map((filterListItem) => {
    return (
      <div key={filterListItem.name}>
        <Paper
          shadow={!isMobile ? "sm" : ""}
          p={isMobile ? 0 : "xs"}
          mb={!isMobile ? 15 : ""}
          withBorder
        >
          <Accordion
            defaultValue={filterListItem.name}
            variant="filled"
            styles={{ panel: { background: "white" } }}
          >
            <Accordion.Item value={filterListItem.name}>
              <Accordion.Control>
                <AccordionFilterLabel
                  label={filterListItem.label}
                  icon={() => filterListItem.icon()}
                  color={filterListItem.color}
                />
              </Accordion.Control>
              <Accordion.Panel>
                <Spoiler
                  maxHeight={430}
                  showLabel="Bekijk meer"
                  hideLabel="Bekijk minder"
                >
                  {filterListItem.options.map((type) => {
                    const checked =
                      houseType?.includes(type.value) ||
                      popularFilters?.includes(type.value);
                    return (
                      <Group
                        key={type.value}
                        position="apart"
                        style={{ marginBottom: 5 }}
                        className="select-none"
                      >
                        <Checkbox
                          label={type.label}
                          id={type.value}
                          checked={checked ?? false}
                          onChange={(event) =>
                            queryHandler(filterListItem.name, event.target.id)
                          }
                          styles={{
                            root: { cursor: "pointer" },
                            inner: { cursor: "pointer" },
                            label: { cursor: "pointer" },
                            input: { cursor: "pointer" },
                          }}
                        />
                        <TotalCountBadge
                          filterType={filterListItem.name}
                          filterItem={type.countKey}
                          countFilterResults={countFilterResults}
                        />
                      </Group>
                    );
                  })}
                </Spoiler>
              </Accordion.Panel>
            </Accordion.Item>
          </Accordion>
        </Paper>
      </div>
    );
  });
};

export default CheckboxFilters;
